// This file was auto-generated using scripts/generate-icons.js

/**
 * Icon generated from file-generic-filled.svg
 *
 * @param {import('preact').JSX.SVGAttributes<SVGSVGElement>} props
 */
export default function FileGenericFilledIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      aria-hidden="true"
      {...props}
    >
      <path
        fill="currentColor"
        d="M11 0v3.5a.5.5 0 0 0 .41.492L11.5 4H15v11.5a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5V.5a.5.5 0 0 1 .5-.5H11ZM7.25 10.5h-2.5a.75.75 0 1 0 0 1.5h2.5a.75.75 0 1 0 0-1.5Zm4-2.75h-6.5a.75.75 0 0 0 0 1.5h6.5a.75.75 0 1 0 0-1.5Zm0-2.75h-6.5a.75.75 0 0 0 0 1.5h6.5a.75.75 0 1 0 0-1.5Zm1.083-5a.5.5 0 0 1 .352.144l2.167 2.143a.5.5 0 0 1 .148.356V3h-2.75a.25.25 0 0 1-.25-.25V0h.333Z"
      />
    </svg>
  );
}
